module.exports = __webpack_public_path__ + "img/Portafolio Mezcla Brava_2.7181be72.png";